import { render, staticRenderFns } from "./mastersales.vue?vue&type=template&id=d9bc7b88&scoped=true"
import script from "./mastersales.vue?vue&type=script&lang=js"
export * from "./mastersales.vue?vue&type=script&lang=js"
import style0 from "./mastersales.vue?vue&type=style&index=0&id=d9bc7b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bc7b88",
  null
  
)

export default component.exports